import ApiClient from './ApiClient';
/* global axios */

class BotInvocationAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  invoke({ conversationId, agentBotId, functionId }) {
    return axios.post(`${this.url}/${conversationId}/bot_invocation`, {
      agent_bot_id: agentBotId,
      function_id: functionId,
    });
  }

  release(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/bot_invocation`);
  }
}

export default new BotInvocationAPI();
